import allFirstLevelObjectKeysAreNonNullable from '@stencil/hotels-utils/src/all-first-level-object-keys-are-nullable';
import megatron from '@stencil/megatron';

type OptionsType = {
  checkinYYYYMMDD: string;
  checkoutYYYYMMDD: string;
  pax: string;
  cityId: string;
  hotelCode: string;
  flavor: 'v3' | 'mobile';
};

type SimilarHotelsAPIResponseTypes = any; // REFACTOR TYPESS

import {apiConfig} from '@stencil/hotels-config';

const {detailsAPIEndPoints} = apiConfig;

export const defaultSimilarHotelsAPIData: SimilarHotelsAPIResponseTypes = {
  data: [],
  city_meta_info: {
    ac: [],
  },
};

const fetchSimilarHotels = async (options: OptionsType) => {
  const {checkinYYYYMMDD, checkoutYYYYMMDD, pax, cityId, hotelCode, flavor} = options;

  if (!allFirstLevelObjectKeysAreNonNullable(options)) {
    return [];
  }

  /** copied from old fore code */
  const filter = {
    gosuggest: [
      {
        vhid: hotelCode,
        type: 0,
      },
    ],
  };

  /** copied from old fore code */
  const queryString = `?&cur=INR&f=${JSON.stringify(filter)}&s=popularity&tmz=-330`;

  // const strQry = `hotels-${cityId}-${checkinYYYYMMDD}-${checkoutYYYYMMDD}-${pax}`;

  const url = detailsAPIEndPoints.similarHotels({
    cityId,
    checkin: checkinYYYYMMDD,
    checkout: checkoutYYYYMMDD,
    hyphenatedPax: pax,
    queryString,
    flavor,
  });

  let similarHotelsData: SimilarHotelsAPIResponseTypes | null = null;
  let error: null | Error = null;

  try {
    const response = await megatron<null, SimilarHotelsAPIResponseTypes>({
      name: 'similarHotels',
      type: 'GET',
      url,
    });

    if (response) {
      similarHotelsData = (response && response) || defaultSimilarHotelsAPIData;
    }
  } catch (e) {}

  return [similarHotelsData, error] as [SimilarHotelsAPIResponseTypes, Error];
};

export default fetchSimilarHotels;
